import React from 'react';
import MuiMultiSelectionDropDown from './MuiMultiSelectionDropDown';
import useOhtList from '@shared/hooks/useOhtList';

/**
 * @typedef {object} SearchControlOHTOwnProps
 * @property {Array<number>} [selectedSearchOHTs]
 * @property {(selectedIds: Array<number>) => void} setSearchOHT
 */

/**
 * @typedef {SearchControlOHTOwnProps &
 *   React.ComponentProps<typeof MuiMultiSelectionDropDown>} SearchControlOHTProps
 */

/**
 * @param {SearchControlOHTProps} props
 */
const SearchControlOHT = props => {
  const { setSearchOHT, selectedSearchOHTs = [], ...otherProps } = props;

  const { ohtList } = useOhtList();

  const selectedValues = ohtList.filter(option => selectedSearchOHTs.includes(option.value));

  const handleOnOptionChange = changedValues => {
    setSearchOHT([...changedValues].filter(x => x.value > 0).map(x => x.value));
  };

  return (
    <div className='search-controls__ohts'>
      <MuiMultiSelectionDropDown
        id='select-oht'
        data-testid='select-oht'
        inputLabel='Filter By OHT(s)'
        disabled={ohtList.length === 0}
        options={ohtList}
        setSelectedValue={handleOnOptionChange}
        selectedValues={selectedValues}
        {...otherProps}
      />
    </div>
  );
};

export default SearchControlOHT;
